import React from 'react';
import moment from 'moment';
import { FormSection } from '../../../components';
import { DatePickerField, FieldMessage } from '@oforce/global-components';

export default function BulkEmailDateSelection({ formik }) {
  const updateFormikValues = activeOnDate => {
    const { initialDocuments, initialData } = formik?.values;
    let filteredDocuments;

    if (activeOnDate === '') {
      filteredDocuments = initialDocuments;
    } else {
      filteredDocuments = initialDocuments
        ?.filter(document => document?.effectiveDate <= activeOnDate)
        ?.filter(document => !document?.expirationDate || document?.expirationDate > activeOnDate);
    }

    const filteredDocumentIds = filteredDocuments?.map(document => document?.id);
    const insuredIds = initialData.filter(x => filteredDocumentIds.includes(x.documentId))?.map(x => x.insuredId);

    formik?.setFieldValue('documentIds', filteredDocumentIds);
    formik?.setFieldValue('documentIdsFilteredByDate', filteredDocumentIds);
    formik?.setFieldValue('documentsFilteredByDate', filteredDocuments);
    formik?.setFieldValue('insuredIdsFilteredByDate', insuredIds);
  };

  return (
    <FormSection title="Generate Documents for this Date">
      <DatePickerField
        fullWidth
        name="activeOn"
        label="Active On"
        format="MM/DD/YYYY"
        onChange={e => {
          const activeOn = !!e ? moment(e).format(moment.HTML5_FMT.DATE) : '';
          formik?.setFieldValue('activeOn', activeOn);
          updateFormikValues(activeOn);
        }}
      />
      <FieldMessage className="w-100" icon={['far', 'info-circle']}>
        If no date is chosen, the most recent active version of the document will be sent
      </FieldMessage>
    </FormSection>
  );
}
